import Marionette from "backbone.marionette";

import PlanosTpl from "views/planos/planos.ejs";
import CSS from "views/planos/planos.css";

import S from "session/session.js";
import T from "session/token.js";

var im = "";
export default Marionette.View.extend({
    initialize: function(data) {
        //console.log(data);
        this.parent = data.parent;
        this.listenTo(this.model, "sync", this.applyView.bind(this));
        this.lupa = 1;
        this.typePlano = data.idPlano;
        this.instance = S.instanceId;
        im = "files/planos/" + S.instanceId + "/urbana.png";

        //im = "files/planos/"+S.instanceId+"/escudo.png";

        var http = new XMLHttpRequest();
        http.open('HEAD', im, false);
        http.send();
        if (http.status == 404) {
            im = "files/planos/" + S.instanceId + "/escudo.png";
            this.lupa = 0;
        }

        this.imagen = im;



    },
    template: PlanosTpl,




    render: function() {

        //console.log("ddd d");
        //web: this.imagen;
        $("#loaderContainer").show();

        this
            .model
            .fetch({
                data: {
                    instanceId: S.instanceId
                },
                beforeSend: T.useToken,
                web: this.imagen,
                lupa: this.lupa
            });

    },
    applyView: function() {

        //TODO: Change header image   
        //console.log("consuelo"+ this.model);         
        S.enviroMenu = this.model.attributes.options;
        //console.log("aaa");
        //S.userInfo.attributes.options = []; //Does not trigger event
        S.userInfo.set({
            options: S.enviroMenu,
            lang: this.model.attributes.lang
        });

        this.$el.html(this.template({
            //options: options,
            lang: this.model.attributes.lang,
            parent: this.parent,
            web: this.imagen,
            lupa: this.lupa
        }));

        /*
                $.ajax({
                    url: "api/mapgis/traductions.php",
                   
                    success:function(){
                        console.log("He llegado hasta aqui");
                    },
                    error: function(){
                        console.log("Esto no funciona asi");
                    }
                    
                    
                    
                });
                */

        $("a#USERS, a#ENVIRO, a#COMPANIES").parent().hide(); // Sidebar            
        $(".centFold").equalHeights({
            onResize: true,
            onLoad: false
        });




        $("#loaderContainer").hide();

    },
    events: {
        "change #planos_tipo": "changePlano"
    },


    changePlano: function(ev) {
        // console.log("prueba29");
        var tipo = $("#planos_tipo option:selected").text();
        tipo = tipo.toLowerCase();

        im = "files/planos/" + S.instanceId + "/" + tipo + ".png";
        this.lupa = 1;
        var http = new XMLHttpRequest();
        http.open('HEAD', im, false);
        http.send();
        if (http.status == 404) {

            im = "files/planos/" + S.instanceId + "/escudo.png";
            this.lupa = 0;
        }

        this.imagen = im;
        //console.log(this.imagen);

        //$(".small").attr("src", im);

        this.$el.html(this.template({
            //options: options,
            lang: this.model.attributes.lang,
            parent: this.parent,
            web: this.imagen,
            lupa: this.lupa
        }));
        var tipo2 = tipo.toUpperCase();
        $(this).find("#planos_tipo selected").addClass("hidden");
        $("#planos_tipo option:selected").text(tipo2);

        //this.listenTo(this.model, "sync", this.applyView.bind(this));
    }

});


//////////////////
// WEBPACK FOOTER
// ./app/views/planos/planos.js
// module id = 203
// module chunks = 0